export default __webpack_public_path__ + "static/media/digital-key-high-res-he.febdfba3.png";